import React from 'react';
import { Image } from 'core/components';

// Banner logos
import threeComLogo from 'app/assets/logos/vendorsBanner/3com_banner.svg';
import a10Logo from 'app/assets/logos/vendorsBanner/a10_banner.svg';
import accedianLogo from 'app/assets/logos/vendorsBanner/accedian_banner.svg';
import acctonLogo from 'app/assets/logos/vendorsBanner/accton_banner.svg';
import adtranLogo from 'app/assets/logos/vendorsBanner/adtran_banner.svg';
import advaLogo from 'app/assets/logos/vendorsBanner/adva_banner.svg';
import alcatellucentLogo from 'app/assets/logos/vendorsBanner/alcatellucent_banner.svg';
import alteonLogo from 'app/assets/logos/vendorsBanner/alteon_banner.svg';
import apcLogo from 'app/assets/logos/vendorsBanner/apc_banner.svg';
import aristaLogo from 'app/assets/logos/vendorsBanner/arista_banner.svg';
import arubaLogo from 'app/assets/logos/vendorsBanner/aruba_banner.svg';
import avocentLogo from 'app/assets/logos/vendorsBanner/avocent_banner.svg';
import broadcomLogo from 'app/assets/logos/vendorsBanner/broadcom_banner.svg';
import brocadeLogo from 'app/assets/logos/vendorsBanner/brocade_banner.svg';
import calixLogo from 'app/assets/logos/vendorsBanner/calix_banner.svg';
import ciscoLogo from 'app/assets/logos/vendorsBanner/cisco_banner.svg';
import cradlepointLogo from 'app/assets/logos/vendorsBanner/cradlepoint_banner.svg';
import cumulusLogo from 'app/assets/logos/vendorsBanner/cumulus_banner.svg';
import dellLogo from 'app/assets/logos/vendorsBanner/dell_banner.svg';
import edgecoreLogo from 'app/assets/logos/vendorsBanner/edgecore_banner.svg';
import extremeLogo from 'app/assets/logos/vendorsBanner/extreme_banner.svg';
import f5Logo from 'app/assets/logos/vendorsBanner/f5_banner.svg';
import force10Logo from 'app/assets/logos/vendorsBanner/force10_banner.svg';
import fortinetLogo from 'app/assets/logos/vendorsBanner/fortinet_banner.svg';
import fsLogo from 'app/assets/logos/vendorsBanner/fs_banner.svg';
import gigamonLogo from 'app/assets/logos/vendorsBanner/gigamon_banner.svg';
import h3cLogo from 'app/assets/logos/vendorsBanner/h3c_banner.svg';
import hpeLogo from 'app/assets/logos/vendorsBanner/hpe_banner.svg';
import huaweiLogo from 'app/assets/logos/vendorsBanner/huawei_banner.svg';
import infineraLogo from 'app/assets/logos/vendorsBanner/infinera_banner.svg';
import infobloxLogo from 'app/assets/logos/vendorsBanner/infoblox_banner.svg';
import ipinfusionLogo from 'app/assets/logos/vendorsBanner/ipinfusion_banner.svg';
import ironportLogo from 'app/assets/logos/vendorsBanner/ironport_banner.svg';
import ixiaLogo from 'app/assets/logos/vendorsBanner/ixia_banner.svg';
import juniperLogo from 'app/assets/logos/vendorsBanner/juniper_banner.svg';
import lantronixLogo from 'app/assets/logos/vendorsBanner/lantronix_banner.svg';
import merakiLogo from 'app/assets/logos/vendorsBanner/meraki_banner.svg';
import metaswitchLogo from 'app/assets/logos/vendorsBanner/metaswitch_banner.svg';
import microsoftLogo from 'app/assets/logos/vendorsBanner/microsoft_banner.svg';
import mikrotikLogo from 'app/assets/logos/vendorsBanner/mikrotik_banner.svg';
import mrvLogo from 'app/assets/logos/vendorsBanner/mrv_banner.svg';
import netappLogo from 'app/assets/logos/vendorsBanner/netapp_banner.svg';
import netgearLogo from 'app/assets/logos/vendorsBanner/netgear_banner.svg';
import netscalerLogo from 'app/assets/logos/vendorsBanner/netscaler_banner.svg';
import nokiaLogo from 'app/assets/logos/vendorsBanner/nokia_banner.svg';
import opengearLogo from 'app/assets/logos/vendorsBanner/opengear_banner.svg';
import paloaltoLogo from 'app/assets/logos/vendorsBanner/paloalto_banner.svg';
import radLogo from 'app/assets/logos/vendorsBanner/rad_banner.svg';
import riverbedLogo from 'app/assets/logos/vendorsBanner/riverbed_banner.svg';
import ruckusLogo from 'app/assets/logos/vendorsBanner/ruckus_banner.svg';
import sandvineLogo from 'app/assets/logos/vendorsBanner/sandvine_banner.svg';
import silverpeakLogo from 'app/assets/logos/vendorsBanner/silverpeak_banner.svg';
import smartopticsLogo from 'app/assets/logos/vendorsBanner/smartoptics_banner.svg';
import sophosLogo from 'app/assets/logos/vendorsBanner/sophos_banner.svg';
import tplinkLogo from 'app/assets/logos/vendorsBanner/tplink_banner.svg';
import ubiquitiLogo from 'app/assets/logos/vendorsBanner/ubiquiti_banner.svg';
import velocloudLogo from 'app/assets/logos/vendorsBanner/velocloud_banner.svg';
import versaLogo from 'app/assets/logos/vendorsBanner/versa_banner.svg';
import vertivLogo from 'app/assets/logos/vendorsBanner/vertiv_banner.svg';
import viptelaLogo from 'app/assets/logos/vendorsBanner/viptela_banner.svg';
import vmwareLogo from 'app/assets/logos/vendorsBanner/vmware_banner.svg';
import vyattaLogo from 'app/assets/logos/vendorsBanner/vyatta_banner.svg';
import zteLogo from 'app/assets/logos/vendorsBanner/zte_banner.svg';

// Icon logos
import threeComIconLogo from 'app/assets/logos/vendorsIcon/3com_icon.svg';
import a10IconLogo from 'app/assets/logos/vendorsIcon/a10_icon.svg';
import accedianIconLogo from 'app/assets/logos/vendorsIcon/accedian_icon.svg';
import acctonIconLogo from 'app/assets/logos/vendorsIcon/accton_icon.svg';
import adtranIconLogo from 'app/assets/logos/vendorsIcon/adtran_icon.svg';
import advaIconLogo from 'app/assets/logos/vendorsIcon/adva_icon.svg';
import alcatellucentIconLogo from 'app/assets/logos/vendorsIcon/alcatellucent_icon.svg';
import alteonIconLogo from 'app/assets/logos/vendorsIcon/alteon_icon.svg';
import apcIconLogo from 'app/assets/logos/vendorsIcon/apc_icon.svg';
import aristaIconLogo from 'app/assets/logos/vendorsIcon/arista_icon.svg';
import arubaIconLogo from 'app/assets/logos/vendorsIcon/aruba_icon.svg';
import avocentIconLogo from 'app/assets/logos/vendorsIcon/avocent_icon.svg';
import broadcomIconLogo from 'app/assets/logos/vendorsIcon/broadcom_icon.svg';
import brocadeIconLogo from 'app/assets/logos/vendorsIcon/brocade_icon.svg';
import calixIconLogo from 'app/assets/logos/vendorsIcon/calix_icon.svg';
import ciscoIconLogo from 'app/assets/logos/vendorsIcon/cisco_icon.svg';
import cradlepointIconLogo from 'app/assets/logos/vendorsIcon/cradlepoint_icon.svg';
import cumulusIconLogo from 'app/assets/logos/vendorsIcon/cumulus_icon.svg';
import dellIconLogo from 'app/assets/logos/vendorsIcon/dell_icon.svg';
import edgecoreIconLogo from 'app/assets/logos/vendorsIcon/edgecore_icon.svg';
import extremeIconLogo from 'app/assets/logos/vendorsIcon/extreme_icon.svg';
import f5IconLogo from 'app/assets/logos/vendorsIcon/f5_icon.svg';
import force10IconLogo from 'app/assets/logos/vendorsIcon/force10_icon.svg';
import fortinetIconLogo from 'app/assets/logos/vendorsIcon/fortinet_icon.svg';
import fsIconLogo from 'app/assets/logos/vendorsIcon/fs_icon.svg';
import gigamonIconLogo from 'app/assets/logos/vendorsIcon/gigamon_icon.svg';
import h3cIconLogo from 'app/assets/logos/vendorsIcon/h3c_icon.svg';
import hpeIconLogo from 'app/assets/logos/vendorsIcon/hpe_icon.svg';
import huaweiIconLogo from 'app/assets/logos/vendorsIcon/huawei_icon.svg';
import infineraIconLogo from 'app/assets/logos/vendorsIcon/infinera_icon.svg';
import infobloxIconLogo from 'app/assets/logos/vendorsIcon/infoblox_icon.svg';
import ipinfusionIconLogo from 'app/assets/logos/vendorsIcon/ipinfusion_icon.svg';
import ironportIconLogo from 'app/assets/logos/vendorsIcon/ironport_icon.svg';
import ixiaIconLogo from 'app/assets/logos/vendorsIcon/ixia_icon.svg';
import juniperIconLogo from 'app/assets/logos/vendorsIcon/juniper_icon.svg';
import lantronixIconLogo from 'app/assets/logos/vendorsIcon/lantronix_icon.svg';
import merakiIconLogo from 'app/assets/logos/vendorsIcon/meraki_icon.svg';
import metaswitchIconLogo from 'app/assets/logos/vendorsIcon/metaswitch_icon.svg';
import microsoftIconLogo from 'app/assets/logos/vendorsIcon/microsoft_icon.svg';
import mikrotikIconLogo from 'app/assets/logos/vendorsIcon/mikrotik_icon.svg';
import mrvIconLogo from 'app/assets/logos/vendorsIcon/mrv_icon.svg';
import netappIconLogo from 'app/assets/logos/vendorsIcon/netapp_icon.svg';
import netgearIconLogo from 'app/assets/logos/vendorsIcon/netgear_icon.svg';
import netscalerIconLogo from 'app/assets/logos/vendorsIcon/netscaler_icon.svg';
import nokiaIconLogo from 'app/assets/logos/vendorsIcon/nokia_icon.svg';
import opengearIconLogo from 'app/assets/logos/vendorsIcon/opengear_icon.svg';
import paloaltoIconLogo from 'app/assets/logos/vendorsIcon/paloalto_icon.svg';
import radIconLogo from 'app/assets/logos/vendorsIcon/rad_icon.svg';
import riverbedIconLogo from 'app/assets/logos/vendorsIcon/riverbed_icon.svg';
import ruckusIconLogo from 'app/assets/logos/vendorsIcon/ruckus_icon.svg';
import sandvineIconLogo from 'app/assets/logos/vendorsIcon/sandvine_icon.svg';
import silverpeakIconLogo from 'app/assets/logos/vendorsIcon/silverpeak_icon.svg';
import smartopticsIconLogo from 'app/assets/logos/vendorsIcon/smartoptics_icon.svg';
import sophosIconLogo from 'app/assets/logos/vendorsIcon/sophos_icon.svg';
import tplinkIconLogo from 'app/assets/logos/vendorsIcon/tplink_icon.svg';
import ubiquitiIconLogo from 'app/assets/logos/vendorsIcon/ubiquiti_icon.svg';
import velocloudIconLogo from 'app/assets/logos/vendorsIcon/velocloud_icon.svg';
import versaIconLogo from 'app/assets/logos/vendorsIcon/versa_icon.svg';
import vertivIconLogo from 'app/assets/logos/vendorsIcon/vertiv_icon.svg';
import viptelaIconLogo from 'app/assets/logos/vendorsIcon/viptela_icon.svg';
import vmwareIconLogo from 'app/assets/logos/vendorsIcon/vmware_icon.svg';
import vyattaIconLogo from 'app/assets/logos/vendorsIcon/vyatta_icon.svg';
import zteIconLogo from 'app/assets/logos/vendorsIcon/zte_icon.svg';

const vendorLogos = {
  '3com': threeComLogo,
  'A10 Networks': a10Logo,
  'accedian, Inc.': accedianLogo,
  'ACCTON Technology': acctonLogo,
  'ADVA AG Optical Networking': advaLogo,
  'Alcatel-Lucent': alcatellucentLogo,
  'Alteon Networks, Inc.': alteonLogo,
  'Arista Networks': aristaLogo,
  'Avocent Corporation': avocentLogo,
  'CradlePoint, Inc': cradlepointLogo,
  'Cumulus Networks, inc': cumulusLogo,
  'Dell Inc.': dellLogo,
  'Dell/Forece10 Networks': force10Logo,
  'Extreme Networks': extremeLogo,
  'Force10 Networks, Inc.': force10Logo,
  'Fortinet, Inc.': fortinetLogo,
  'FS.COM INC': fsLogo,
  'Gigamon Systems LLC': gigamonLogo,
  'Hewlett Packard Enterprise': hpeLogo,
  'Hewlett-Packard': hpeLogo,
  'HP/H3c': h3cLogo,
  'HPE/Compaq': hpeLogo,
  'HUAWEI Technology Co.,Ltd': huaweiLogo,
  'InfoBlox Inc.': infobloxLogo,
  'IP Infusion Inc': ipinfusionLogo,
  'IronPort Systems, Inc.': ironportLogo,
  'IXIA Communications': ixiaLogo,
  'Juniper Networks': juniperLogo,
  'Meraki Networks, Inc.': merakiLogo,
  'Metaswitch Networks, Ltd.': metaswitchLogo,
  'MRV Communications': mrvLogo,
  'Palo Alto Networks': paloaltoLogo,
  'Palo-Alto': paloaltoLogo,
  'Riverbed Technology, Inc.': riverbedLogo,
  'Ruckus Wireless, Inc.': ruckusLogo,
  'Silver Peak Systems, Inc.': silverpeakLogo,
  'Silver-Peak': silverpeakLogo,
  'SmartOptics AS': smartopticsLogo,
  'Sophos Plc': sophosLogo,
  'TP-Link': tplinkLogo,
  'Ubiquiti EdgeMax': ubiquitiLogo,
  'Ubiquiti Networks, Inc.': ubiquitiLogo,
  'Velocloud Networks, Inc.': velocloudLogo,
  'Versa Networks, Inc': versaLogo,
  'Viptela, Inc.': viptelaLogo,
  'VMWare Inc.': vmwareLogo,
  Adtran: adtranLogo,
  APC: apcLogo,
  Arista: aristaLogo,
  Aruba: arubaLogo,
  Broadcom: broadcomLogo,
  Brocade: brocadeLogo,
  "Brocade (formerly 'Foundry Networks, Inc.')": brocadeLogo,
  "Brocade Communication Systems, Inc. (formerly 'Foundry Networks, Inc.')": brocadeLogo,
  'Brocade Communications Systems, Inc.': brocadeLogo,
  Calix: calixLogo,
  Cisco: ciscoLogo,
  EdgeCore: edgecoreLogo,
  Extreme: extremeLogo,
  F5: f5Logo,
  Huawei: huaweiLogo,
  'Lumentis AB': infineraLogo,
  'Coriant R&D GmbH': infineraLogo,
  'Infinera Corp.': infineraLogo,
  Juniper: juniperLogo,
  Lantronix: lantronixLogo,
  Microsoft: microsoftLogo,
  MikroTik: mikrotikLogo,
  NetApp: netappLogo,
  Netgear: netgearLogo,
  Netscaler: netscalerLogo,
  Nokia: nokiaLogo,
  Opengear: opengearLogo,
  RAD: radLogo,
  Riverbed: riverbedLogo,
  Sandvine: sandvineLogo,
  Ubiquiti: ubiquitiLogo,
  Vertiv: vertivLogo,
  "Vertiv (formerly 'Emerson Computer Power')": vertivLogo,
  Vyatta: vyattaLogo,
  VyOS: vyattaLogo,
  ZTE: zteLogo
};

const vendorIconLogos = {
  '3com': threeComIconLogo,
  'A10 Networks': a10IconLogo,
  'accedian, Inc.': accedianIconLogo,
  'ACCTON Technology': acctonIconLogo,
  'ADVA AG Optical Networking': advaIconLogo,
  'Alcatel-Lucent': alcatellucentIconLogo,
  'Alteon Networks, Inc.': alteonIconLogo,
  'Arista Networks': aristaIconLogo,
  'Avocent Corporation': avocentIconLogo,
  'CradlePoint, Inc': cradlepointIconLogo,
  'Cumulus Networks, inc': cumulusIconLogo,
  'Dell Inc.': dellIconLogo,
  'Dell/Forece10 Networks': force10IconLogo,
  'Extreme Networks': extremeIconLogo,
  'Force10 Networks, Inc.': force10IconLogo,
  'Fortinet, Inc.': fortinetIconLogo,
  'FS.COM INC': fsIconLogo,
  'Gigamon Systems LLC': gigamonIconLogo,
  'Hewlett Packard Enterprise': hpeIconLogo,
  'Hewlett-Packard': hpeIconLogo,
  'HP/H3c': h3cIconLogo,
  'HPE/Compaq': hpeIconLogo,
  'HUAWEI Technology Co.,Ltd': huaweiIconLogo,
  'InfoBlox Inc.': infobloxIconLogo,
  'IP Infusion Inc': ipinfusionIconLogo,
  'IronPort Systems, Inc.': ironportIconLogo,
  'IXIA Communications': ixiaIconLogo,
  'Juniper Networks': juniperIconLogo,
  'Meraki Networks, Inc.': merakiIconLogo,
  'Metaswitch Networks, Ltd.': metaswitchIconLogo,
  'MRV Communications': mrvIconLogo,
  'Palo Alto Networks': paloaltoIconLogo,
  'Palo-Alto': paloaltoIconLogo,
  'Riverbed Technology, Inc.': riverbedIconLogo,
  'Ruckus Wireless, Inc.': ruckusIconLogo,
  'Silver Peak Systems, Inc.': silverpeakIconLogo,
  'Silver-Peak': silverpeakIconLogo,
  'SmartOptics AS': smartopticsIconLogo,
  'Sophos Plc': sophosIconLogo,
  'TP-Link': tplinkIconLogo,
  'Ubiquiti EdgeMax': ubiquitiIconLogo,
  'Ubiquiti Networks, Inc.': ubiquitiIconLogo,
  'Velocloud Networks, Inc.': velocloudIconLogo,
  'Versa Networks, Inc': versaIconLogo,
  'Viptela, Inc.': viptelaIconLogo,
  'VMWare Inc.': vmwareIconLogo,
  Adtran: adtranIconLogo,
  APC: apcIconLogo,
  Arista: aristaIconLogo,
  Aruba: arubaIconLogo,
  Broadcom: broadcomIconLogo,
  Brocade: brocadeIconLogo,
  "Brocade (formerly 'Foundry Networks, Inc.')": brocadeIconLogo,
  "Brocade Communication Systems, Inc. (formerly 'Foundry Networks, Inc.')": brocadeIconLogo,
  'Brocade Communications Systems, Inc.': brocadeIconLogo,
  Calix: calixIconLogo,
  Cisco: ciscoIconLogo,
  EdgeCore: edgecoreIconLogo,
  Extreme: extremeIconLogo,
  F5: f5IconLogo,
  Huawei: huaweiIconLogo,
  'Lumentis AB': infineraIconLogo,
  'Coriant R&D GmbH': infineraIconLogo,
  'Infinera Corp.': infineraIconLogo,
  Juniper: juniperIconLogo,
  Lantronix: lantronixIconLogo,
  Microsoft: microsoftIconLogo,
  MikroTik: mikrotikIconLogo,
  NetApp: netappIconLogo,
  Netgear: netgearIconLogo,
  Netscaler: netscalerIconLogo,
  Nokia: nokiaIconLogo,
  Opengear: opengearIconLogo,
  RAD: radIconLogo,
  Riverbed: riverbedIconLogo,
  Sandvine: sandvineIconLogo,
  Ubiquiti: ubiquitiIconLogo,
  Vertiv: vertivIconLogo,
  "Vertiv (formerly 'Emerson Computer Power')": vertivIconLogo,
  Vyatta: vyattaIconLogo,
  VyOS: vyattaIconLogo,
  ZTE: zteIconLogo
};

function VendorLogo({ customFallback, fallback = false, icon, logoStyle, name }) {
  const vendorLogo = vendorLogos[name];
  const vendorIconLogo = vendorIconLogos[name];

  if (vendorIconLogo && icon) {
    return <Image src={vendorIconLogo} alt={name} style={logoStyle} />;
  }
  if (vendorLogo) {
    return <Image src={vendorLogo} alt={name} style={logoStyle} />;
  }
  if (fallback) {
    return customFallback || name || '';
  }
  return null;
}

export default VendorLogo;
